import * as types from './types'
import { filterService } from '@/_services'

const actions = {
  selectResource ({ commit }, data) {
    commit(types.SELECT_RESOURCE, data)
  },
  updateResource ({ commit }, data) {
    commit(types.UPDATE_SELECTED_RESOURCE, data)
  },
  selectResourceSecond ({ commit }, data) {
    commit(types.SELECT_RESOURCE_SECOND, data)
  },
  updateResourceSecond ({ commit }, data) {
    commit(types.UPDATE_SELECTED_RESOURCE_SECOND, data)
  },
  changeListPage ({ commit }, page) {
    commit(types.CHANGE_LIST_PAGE, page)
  },
  toggleCheckAll ({ commit }, data) {
    commit(types.TOGGLE_CHECK_ALL, data)
  },
  toggleCheckResource ({ commit }, data) {
    commit(types.TOGGLE_CHECK_RESOURCE, data)
  },
  clearResourceStore ({ commit }) {
    commit(types.CLEAR_RESOURCES_STORE)
  },
  setContextFooter ({ commit }, data) {
    commit(types.SET_CONTEXT_FOOTER)
  },
  setContentLastUrl ({ commit }, { url }) {
    // Keep the last overview url in state, so when back buttons is pushed to return to the proper state (algolia filters and page)
    commit(types.SET_CONTENT_LAST_URL, { url })
  },
  setResourceOverviewList ({ commit }, { index, query, filters, pageSize, page, indexRef }) {
    let appliedFilters = []
    if (filters !== undefined) {
      const filtersObject = {}
      filters.forEach((ArrayOfFacets) => {
        ArrayOfFacets.forEach(({ facet, value }) => {
          if (filtersObject[facet] !== undefined) {
            filtersObject[facet].push(value)
          } else {
            filtersObject[facet] = [value]
          }
        })
      })
      appliedFilters = Object.keys(filtersObject).map((key) => {
        return {
          type: key,
          string: filtersObject[key]
        }
      })
    }
    commit(types.IS_FETCHING_LIST, { flag: true })
    const searchIndex = indexRef != null ? indexRef : index
    filterService[searchIndex]({ query, filters: appliedFilters, pageSize, page }).then(({ items, total }) => {
      commit(types.SET_RESOURCE_LIST, { items })
      commit(types.SET_TOTAL_NUMBER_OVERVIEW_LIST, { total })
      commit(types.CHANGE_LIST_PAGE, page)
    }).finally(() => {
      commit(types.IS_FETCHING_LIST, { flag: false })
    })
  },
  addResourceOverviewListItem ({ commit }, { item }) {
    commit(types.ADD_RESOURCE_LIST_ITEM, { item })
  },
  setSecondResourceOverviewList ({ commit }, { id, index, page, items }) {
    if (index != null) {
      filterService[index]({ id }).then(({ items, total }) => {
        commit(types.SET_SECOND_RESOURCE_LIST, { items })
        // commit(types.SET_TOTAL_NUMBER_OVERVIEW_LIST, { total })
        // commit(types.CHANGE_LIST_PAGE, page)
      })
    } else {
      commit(types.SET_SECOND_RESOURCE_LIST, { items })
    }
  },
  addSecondResourceOverviewListItem ({ commit }, { item }) {
    commit(types.ADD_SECOND_RESOURCE_LIST_ITEM, { item })
  },
  removeSecondResourceOverviewListItem ({ commit }, { item }) {
    commit(types.REMOVE_SECOND_RESOURCE_LIST_ITEM, { item })
  },
  updateSecondResourceOverviewList ({ commit }, { item }) {
    commit(types.UPDATE_SECOND_RESOURCE_LIST, { item })
  },
  unselectResource ({ commit }) {
    commit(types.UNSELECT_RESOURCE)
  }
}
export default actions
